/** Google Ads API OAuth scope. One scope covers every read and write call. */
export const GOOGLE_ADS_SCOPE = "https://www.googleapis.com/auth/adwords";

export const GOOGLE_SCOPES = [GOOGLE_ADS_SCOPE];

export function googleGrants(
  held: ReadonlyArray<string>,
  required: string,
): boolean {
  return held.includes(required);
}
